import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { loginUserManual } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

function Auth() {
    const navigate = useNavigate();
    const { login, user, loading: authLoading } = useAuth();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [isLogin] = useState(true);
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const selectedGender = localStorage.getItem('selectedGender');

    useEffect(() => {
        // If user is already logged in, redirect to appropriate dashboard
        if (!authLoading && user) {
            if (user.gender === 'female' && user.status === 'rejected') {
                navigate('/waiting');
            } else if (user.gender === 'female' && !user.isApproved) {
                navigate('/waiting');
            } else if (user.gender === 'female' && user.isApproved) {
                navigate('/female-dashboard');
            } else if (user.gender === 'male') {
                navigate('/male-dashboard');
            }
        }
    }, [user, authLoading, navigate]);

    if (!selectedGender) {
        navigate('/');
        return null;
    }

    if (authLoading) {
        return <div className="auth-page"><div className="loading">Loading...</div></div>;
    }

    // Manual login/register form for both male and female users
    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleManualLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await loginUserManual(formData.username, formData.password);
            login(response.user);
            
            // Navigate based on gender and approval status
            if (response.user.gender === 'female' && !response.user.isApproved) {
                navigate('/waiting');
            } else if (response.user.gender === 'female' && response.user.isApproved) {
                navigate('/female-dashboard');
            } else {
                navigate('/male-dashboard');
            }
        } catch (error) {
            console.error('Login error:', error);
            setError(error.response?.data?.message || error.message || 'Login failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-card">
                    <h1>{isLogin ? 'Sign In' : 'Sign Up'}</h1>
                    <p className="subtitle">
                        {selectedGender === 'female' 
                            ? 'Sign in as Female Model'
                            : isLogin 
                                ? 'Sign in to your account' 
                                : 'Create a new account'}
                    </p>

                    {error && (
                        <div className="error-message">
                            {error}
                        </div>
                    )}

                    {isLogin ? (
                        <form onSubmit={handleManualLogin}>
                            <div className="form-group">
                                <label>Username or Email</label>
                                <input
                                    type="text"
                                    name="username"
                                    value={formData.username}
                                    onChange={handleInputChange}
                                    required
                                    placeholder="Enter your username or email"
                                />
                            </div>

                            <div className="form-group">
                                <label>Password</label>
                                <input
                                    type="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    required
                                    placeholder="Enter your password"
                                />
                            </div>

                            <button 
                                type="submit"
                                className="submit-btn"
                                disabled={loading}
                            >
                                {loading ? 'Signing in...' : 'Sign In'}
                            </button>

                            <p className="switch-form">
                                Don't have an account?{' '}
                                <Link to="/register">Sign up</Link>
                            </p>
                        </form>
                    ) : null}

                    <button 
                        className="back-btn"
                        onClick={() => navigate('/')}
                        disabled={loading}
                    >
                        Back
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Auth;